<template>
  <div class="aboutus">
    <div class="zong">
      <div class="title">
        <h1 style="color:white;"
        :class="{'animate__animated': isVisible, 'animate__bounceInLeft': isVisible, 'fixed-text': isFixed}"
        v-show="isVisible"
          @animationend="handleAnimationEnd">
          ABOUT <br>US
        </h1>
        <h1 style="color:#76BD25;"
        :class="{ 'animate__animated': isVisible, 'animate__fadeIn': isVisible }"
        v-show="isVisible"
          @animationend="handleAnimationEnd">
          ———
        </h1>
        <h1 style="color:white;"
        :class="{'animate__animated': isVisible, 'animate__bounceInLeft': isVisible, 'fixed-text': isFixed}"
        v-show="isVisible"
          @animationend="handleAnimationEnd">
          关于我们
        </h1>
      </div>

      <div class="text">
        <p>浙江固德医药有限公司地处浙江温州，建筑面积1万余平方米。按现代物流标准设立的医药批发企业。</p>
        <p>公司以经营药品、中药饮片、医疗器械、食品等为主营业务；以医药专业分销、现代物流、电子商务及终端零售为主要经营业态。</p>
        <p>公司秉承 “同创造 共发展 齐分享” 的企业理念，致力于给百姓带去健康快乐；给客户和伙伴带来超值利益；给员工提供实现自身价值的平台；给企业创造持续发展的空间。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false,
      scrollY: 0,
      isFixed: false,
    }
  },
  methods: {
    handleScroll() {
      this.scrollY = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
      if (this.scrollY > 1800) {
        this.isVisible = true;
      }
    },
    handleAnimationEnd() {
      this.isFixed = true;
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>

<style scoped>
  .aboutus{
    max-width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 820px;
    background-image: url("../../assets/images/new/about.jpg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
    .zong{
      max-width: 1200px;
      display: flex;
      flex-direction: column;
      height: 550px;
    }
    .title{
      max-width: 1200px;
    }
    .title h1{
      font-weight:bold;
      font-size: 2.5rem;
    }
    .text{
      justify-content: center;
      display: flex;
      flex-direction: column;
      height: 400px;
      max-width: 1200px;
    }
    .text>p{
      text-indent: 2rem;
      color: white;
      font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
      font-size: 17px;
      line-height: 35px;
      letter-spacing:1px;
    }
    @media (max-width: 1200px){
    .title h1{
      font-size: 2.0rem;
    }
    .title{
      margin-left: 60px;
    }
  }
    @media (max-width: 500px){
    .title h1{
      font-size: 1.5rem;
    }
    }
    @media (max-width: 400px){
    .title{
      margin: 0 auto;
    }
    
    }
</style>